import { SET_PAYMENT_METHOD } from 'actions/account/checkout/actionTypes'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_PAYMENT_METHOD:
      return action.paymentMethod
    default:
      return state
  }
}

export default reducer
